import { Pipe, PipeTransform } from '@angular/core';
import { WhitelabelConfiguration } from '../models/whitelabel-config';

@Pipe({
  standalone: false,
  name: 'alphabeticalSort'
})
export class AlphabeticalSortPipe implements PipeTransform {

  transform(value: WhitelabelConfiguration[]): WhitelabelConfiguration[] {
    const elements = value;
    const alphabeticalSortedElements = elements.sort((elementA, elementB) => {
      const elementAAppName = elementA.name.toLowerCase();
      const elementBAppName = elementB.name.toLowerCase();

      return elementAAppName.localeCompare(elementBAppName);
    })

    return alphabeticalSortedElements;
  }

}
